import { useState } from "react";
import EditButton from "../../components/EditButton";
import HideButton from "../../components/HideButton";
import ShowButton from "../../components/ShowButton";
import Table from "../../components/tables/Table";
import UploadFileButton from "../../components/UploadFileButton";
import TemplateButton from "../../components/TemplateButton";
import Modal from "../../components/Modal";
const MassUpload = ({ isOpen, setMassUploadModal }) => {
  const [allData, setAllData] = useState([]);
  const [selectedTab, setSelectedTab] = useState("All");
  const [origData, setOrigData] = useState([]);

  const columns = [
    {
      name: "Carrier",
      selector: (row) => row.carrierName,
    },
    {
      name: "State",
      selector: (row) => row.state,
    },
    {
      name: "Fee Type",
      selector: (row) => row.feeType,
    },
    {
      name: "Fee Amount",
      selector: (row) => row.feeAmount,
    },
    {
      name: "Policy Term",
      selector: (row) => row.policyTerm,
    },
    {
      name: "Fee Level",
      selector: (row) => row.feeLevel,
    },
    {
      name: "Effective Date",
      selector: (row) => row.effectiveDate,
    },
    {
      name: "Expiration Date",
      selector: (row) => row.expirationDate,
    },
    {
      name: "Actions",
      center: "true",
      cell: (row) => {
        return (
          <div className="flex 2xl:flex-row flex-col justify-center items-center">
            <div className="flex flex-row text-xs3 ">
              {row.expandRow ? (
                <HideButton buttonText="Hide" onClick={() => {}} />
              ) : (
                ""
              )}

              <div className="flex flex-row flex-col justify-center items-center opacity-100 gap-x-2 space-x-1">
                {row.expandRow ? (
                  ""
                ) : (
                  <ShowButton
                    className={""}
                    buttonText="Show"
                    onClick={() => {}}
                  />
                )}

                {row.expandRow ? (
                  ""
                ) : (
                  <EditButton
                    className={""}
                    buttonText="Edit"
                    onClick={() => {}}
                  />
                )}
              </div>
            </div>
          </div>
        );
      },
    },
  ];
  const tabs = ["All", "Valid", "Invalid"];
  const handleSelectedTab = (tab, data) => {
    setSelectedTab(tab);

    switch (tab) {
      case "All":
        return setAllData(origData);
      case "Valid":
        if (data !== null) {
          const valids = data.filter((data) => data.isValid);
          setAllData(valids);
        } else {
          const valids = origData.filter((data) => data.isValid);
          setAllData(valids);
        }
        return;
      case "Invalid":
        if (data !== null) {
          const invalids = data.filter((data) => !data.isValid);
          setAllData(invalids);
        } else {
          const invalids = origData.filter((data) => !data.isValid);
          setAllData(invalids);
        }

      default:
        return;
    }
  };
  const closeModal = () => {
    setMassUploadModal(false);
  };
  return (
    <Modal isOpen={isOpen} onClose={() => closeModal()} closeOutside={false}>
      <div className="font-bold text-xl flex items-center m-2">
        <div className="text-base text-primary font-bold">
          {"Policy Fee Mass Upload"}
        </div>
        <div className="ml-auto flex items-center ">
          <TemplateButton onClick={""} />
          <UploadFileButton onChange={""} disabled={false} />
        </div>
      </div>
      <div className="mt-2 h-1 w-full border-b-2 border-secondary" />
      <div>
        <div className="flex items-end">
          {tabs.map((tab, index) => {
            return (
              <button
                key={index}
                onClick={() => handleSelectedTab(tab, null)}
                className={`border-b-4 font-medium text-sm text-tertiary cursor-pointer transition py-3 px-5  
             ${
               selectedTab === tab
                 ? "border-primary font-bold bg-gray-50"
                 : "border-transparent hover:bg-gray-50  "
             }`}
              >
                {tab}
              </button>
            );
          })}
        </div>
        <div className="mt-6">
          <Table data={allData} columns={columns} />
        </div>
      </div>
    </Modal>
  );
};
export default MassUpload;
